import { type ReactNode, createContext } from 'react'
import type { UserInfosResponse } from '~/api/queries/user'
import type { ApplicantModalType, AsideActionPosition } from '~/types/global'

export const AuthContext = createContext<UserInfosResponse | null>(null)

export const AsideActionContext = createContext<{
  asideAction: ReactNode | null
  isWide: boolean
  position: AsideActionPosition
  availablePositions: AsideActionPosition[]
  isDirty: boolean
  setAsideAction: ({
    action,
    isWide,
    position,
    availablePositions
  }: {
    action: ReactNode
    isWide?: boolean
    position?: AsideActionPosition
    availablePositions?: AsideActionPosition[]
  }) => void
  setPosition: (position: AsideActionPosition) => void
  setIsDirty: (isDirty: boolean) => void
  resetAction: () => void
}>({
  asideAction: null,
  isWide: false,
  position: 'sidebar',
  availablePositions: ['sidebar'],
  isDirty: false,
  setPosition: () => { },
  setAsideAction: () => { },
  setIsDirty: () => { },
  resetAction: () => { }
})

export const ApplicantModalContext = createContext<{
  applicantCollection: ApplicantModalType[]
  setApplicantCollection: (applicants: ApplicantModalType[]) => void
  applicantCurrentId: number | null
  setApplicantCurrentId: (id: number | null) => void
}>({
  applicantCollection: [],
  setApplicantCollection: () => { },
  applicantCurrentId: null,
  setApplicantCurrentId: () => { }
})
